import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '@/lib/auth';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAuth?: boolean;
  requireAdmin?: boolean;
}

export default function ProtectedRoute({ 
  children, 
  requireAuth = true, 
  requireAdmin = false 
}: ProtectedRouteProps) {
  const currentUser = authService.getCurrentUser();

  if (requireAuth && !currentUser) {
    return <Navigate to="/login" replace />;
  }

if (requireAdmin && (!currentUser || currentUser.role !== 'admin')) {
  return <Navigate to="/" replace />;
}
if (requireAdmin && currentUser?.role !== 'admin') {
  return <Navigate to="/unauthorized" replace />;
}


  return <>{children}</>;
}